module.exports = __webpack_public_path__ + "img/ic_star_bright.d975971e.png";